
export class RoomEventApi {
    #isRunEvent = false;
    #eventQueue = [];
    #eventListenersMap = {};

    constructor(options={}) {
    }

    addEventListener(type, listener, options) {
        let list = this.#eventListenersMap[type];
        if(!list){
            this.#eventListenersMap[type] = list = [];
        }
        options = options || {}
        list.push({
            listener, options
        });

        if(options.order){
            list.sort((a,b) => {
                if(!a.options.order){
                    if(!b.options.order){
                        return 0;
                    }
                    return 1;
                }else if(!b.options.order){
                    return -1;
                }
                return a.options.order - b.options.order
            })
        }

        return this;
    }
    addEventListeners(listeners, instance) {
        if(instance && instance === this){
            instance = null;
        }

        function bind(listener, instance){
            if(!instance){
                return listener;
            }

            const func = function(){
                listener.apply(instance, arguments);
            }
            func.apply = function(instance, args){
                listener.apply(instance, args);
            }
            return func;
        }

        if(Array.isArray(listeners)){
            listeners.forEach(o => {
                if(instance){
                    o.listener = bind(o.listener, instance); //o.listener.bind(instance);
                }
                this.addEventListener(o.type, o.listener);
            });
        }else if(typeof listeners === 'object'){
            for(let type in listeners){
                let listener = listeners[type]
                    = instance ? bind(listeners[type], instance) //listeners[type].bind(instance)
                            : listeners[type];
                this.addEventListener(type, listener);
            }
        }
    }

    removeEventListeners(listeners) {
        if(Array.isArray(listeners)){
            listeners.forEach(o => {
                this.removeEventListener(o.type, o.listener);
            });
        }else if(typeof listeners === 'object'){
            for(let type in listeners){
                this.removeEventListener(type, listeners[type]);
            }
        }
    }

    removeEventListener(type, listener) {
        let list = this.#eventListenersMap[type];
        if(!list){
            return this;
        }

        if(!listener){
            delete this.#eventListenersMap[type];
            return this;
        }

        for(let i=0; i<list.length; i++){
            if(list[i].listener !== listener){
                continue;
            }
            list.splice(i, 1);
            break;
        }

        return this;
    }

    async trigger(type, data) {
        let e = null;
        if(typeof type === 'object'){
            e = type;
            type = e.type;
        }

        let list = this.#eventListenersMap[type];
        if(!list || list.length === 0){
            // console.warn('unknown event :', type, data);
            return this;
        }

        if(!e){
            e = {
                type,
                data,
                eventTime: new Date()
            };
        }

        let works;
        // event 수행 중 remove 되는 케이스로 성능은 3~5배 떨어지나 대용량 외에 무의미하다고 판단되어 concat 처리.
        list = list.concat();
        for(let i=0; i<list.length; i++){
            let obj = list[i];
            let rt = obj.listener(e);
            if(rt instanceof Promise){
                if(!works) works = [];
                works.push(rt);
            }

            if(obj.options && obj.options.once){
                list.splice(i, 1);
                i--;
            }
        }

        if(works){
            let result = await Promise.all(works);
            return result;
        }
        return;
    }

    async pushEvent(event, data) {
        if(typeof event === 'string'){
            event = {
                type: event,
                data
            };
        }

        this.#eventQueue.push(event);
        await this._runEvent()
    }

    async _runEvent() {
        if(!this.#isRunEvent){
            return;
        }

        let event;
        while(
            (event = this.#eventQueue.shift())
        ){
            // try{
            //     console.log('@@@@@@@@@@@@ st :', event);
                await this.trigger(event);
            //     console.log('@@@@@@@@@@@@ ed :', event);
            // }catch(e){
            //     console.error('@@@@@@@ err :', event, e);
            //     throw e;
            // }
        }
    }

    pauseEvent() {
        this.#isRunEvent = false;
        return this;
    }

    async runEvent() {
        this.#isRunEvent = true;
        await this._runEvent();
        return this;
    }
}

export const roomEventApi = new RoomEventApi();